import { Locale } from 'src/state/Locale';

export const LOCALE: Locale = window.location.pathname.startsWith('/de')
    ? 'de'
    : 'en';
